export default __webpack_public_path__ + "static/media/Close.09b8f963.svg";